<template>
    <div class="modal-content-padding">
        <div class="row">
            <!-- TITLE -->
            <div class="col-sm-11 mt-1">
                <h5>{{ $t('global_search') }}</h5>
            </div>
            <!-- BUTTON: CLOSE MODAL -->
            <div class="col-sm-1">
                <button class="btn btn-danger float-right" @click="close()">
                    {{ $t('close') }}
                </button>
            </div>
        </div>
        <!-- SEARCH FIELD -->
        <div class="form-group row mt-3">
            <div class="col">
                <label for="nameVnr">{{ $t('name') }} / {{ $t('vnr') }}</label>
                <input id="nameVnr" type="text" class="form-control" v-on:keyup="getMedsDelay" v-model="searchName" />
            </div>
        </div>
        <!-- RESULTS (LOADING) -->
        <template v-if="loading">
            <b-row class="text-center mt-5">
                <b-col>
                    <b-spinner label="Loading..."></b-spinner>
                </b-col>
            </b-row>
        </template>
        <!-- RESULTS (LOADED) -->
        <ul class="list-group" v-else>
            <li class="list-group-item" v-for="med in medications" v-bind:key="med.vnr" @click="choose(med)">
                {{ getMedDisplayName(med, true, false) }}
            </li>
        </ul>
        <div class="row"></div>
    </div>
</template>
<script>
import { getFilteredMedications, handleAxiosError } from '@/services/axiosService';
import { getMedDisplayName } from '@/services/medicationService';

export default {
    data() {
        return {
            getMedDisplayName,
            loading: false,
            medications: [],
            searchName: '',
            searchDelay: 500,
            timer: null
        };
    },
    methods: {
        // close modal
        close() {
            this.$emit('close');
        },
        // get medications with delay (to prevent unnecessary queries)
        getMedsDelay() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.getMeds(), this.searchDelay);
        },
        // get medications based on search query
        async getMeds() {
            // proceed only if at least three digits entered
            if (this.searchName.length >= 3) {
                try {
                    this.loading = true;
                    // set search params
                    const params = {
                        searchName: this.searchName,
                        searchNameExact: false,
                        searchVnr: this.searchName,
                        searchVnrExact: false
                    };
                    this.medications = await getFilteredMedications({ params });
                } catch (error) {
                    handleAxiosError(error);
                }
            } else if (this.searchName.length < 3 && this.medications.length > 0) {
                this.medications = [];
            }
            this.loading = false;
        },
        // choose medication (execute 'update' action with selected vnr and close modal)
        choose(value) {
            this.$attrs.update(value);
            this.$emit('close');
        }
    }
};
</script>
<style>
li {
    cursor: pointer;
}
li:hover {
    color: darkgreen;
}
.v--modal {
    overflow-y: initial !important;
}
</style>
